var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex rounded-full bg-primary overflow-hidden",staticStyle:{"width":"fit-content","box-shadow":"0px -1px 20px 0px #c1c1c1"}},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab.value,staticClass:"px-2.5 py-1 flex items-center",class:{
      'pl-4': index === 0,
      'pr-4': index === _vm.tabs.length - 1,
      'cursor-pointer': tab.value !== _vm.value,
      'bg-secondary': tab.value === _vm.value,
      'text-white': tab.value === _vm.value,
      underline: tab.value !== _vm.value,
      'cursor-default': tab.value === _vm.value
    },on:{"click":function($event){return _vm.$emit('input', tab.value)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }